import { render, staticRenderFns } from "./RecordVideoQuestion.vue?vue&type=template&id=4bffc285"
import script from "./RecordVideoQuestion.vue?vue&type=script&lang=js"
export * from "./RecordVideoQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports